import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Search, Tag, TrendingUp, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Search className="w-8 h-8" data-id="element-155" />,
    title: 'For Buyers',
    description: 'Access to both on and off-market properties. I help you find the hidden gems in Gilbert and beyond before they hit the public sites.',
    link: '#contact'
  }, {
    icon: <Tag className="w-8 h-8" data-id="element-156" />,
    title: 'For Sellers',
    description: 'Strategic pricing and premium marketing that positions your home as a luxury asset, ensuring you get top dollar in any market conditions.',
    link: '#contact'
  }, {
    icon: <TrendingUp className="w-8 h-8" data-id="element-157" />,
    title: 'For Investors',
    description: 'Leveraging my 4 years of investment background to identify high-yield opportunities, flips, and long-term rentals with solid cap rates.',
    link: '#contact'
  }];
  return <Section id="services" background="light" data-id="element-158">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-159">
        <h4 className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-160">
          My Services
        </h4>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-dark" data-id="element-161">
          Comprehensive Real Estate Solutions
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-162">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-white p-8 md:p-10 shadow-sm hover:shadow-xl transition-all duration-300 group border-t-4 border-transparent hover:border-brand-gold" data-id="element-163">
            <div className="w-16 h-16 bg-brand-light rounded-full flex items-center justify-center text-brand-dark mb-6 group-hover:bg-brand-gold group-hover:text-white transition-colors duration-300" data-id="element-164">
              {service.icon}
            </div>
            <h3 className="text-xl font-bold mb-4 text-brand-dark" data-id="element-165">
              {service.title}
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-166">
              {service.description}
            </p>
            <a href={service.link} className="inline-flex items-center text-brand-gold font-semibold text-sm uppercase tracking-wide group-hover:text-brand-dark transition-colors" data-id="element-167">
              Learn More{' '}
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-168" />
            </a>
          </motion.div>)}
      </div>
    </Section>;
}